import { Injectable } from '@angular/core';
import { ModalService } from '@common/services/modal.service';
import { MessageBoxComponent } from '@common/popups/message-box/message-box.component';
import { Multilingual } from '@core/utilities/multilingual';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MessageBoxService {

  constructor(private modal: ModalService) {
  }

  public informs(message: string) {
    this.modal.show(MessageBoxComponent, {
      ignoreBackdropClick: false, state: {
        closable: true,
        message: Multilingual.getText(message),
        title: Multilingual.getText("Thông báo")
      }
    });
  }

  public confirms(mode: 'encourage' | 'discourage', message: string, commit: () => Observable<boolean>) {
    this.modal.show(MessageBoxComponent, {
      ignoreBackdropClick: true, state: {
        closable: false,
        message: Multilingual.getText(message),
        title: Multilingual.getText("Xác nhận"),
        buttons: [
          {
            icon: 'fa fa-check', class: (mode == 'encourage' ? 'bg-success' : 'bg-danger') + ' text-white', name: Multilingual.getText('Xác nhận'), click: e => {

              commit().subscribe(succeed => {
                if (!succeed) {
                  this.informs("Xác nhận không thành công. xin vui lòng thử lại!");
                }
              });              
            }
          },

          { icon: "fa fa-undo", class: 'bg-warning text-white', name: Multilingual.getText('Quay lại') }
        ]
      }
    });  
  }
}
